import { useTranslation } from "react-i18next";

// * Here for data data select control
export const fullBorderExcel = {
  borderLeft: 2,
  borderRight: 2,
  borderTop: 2,
  borderBottom: 2,
};

export const headerCellOptions = {
  ...fullBorderExcel,
  bold: true,
  background: "#CF642A",
  fontSize: 12,
  textAlign: "center",
  color: "#ffffff",
  verticalAlign: "center",
  fontFamily: "Khmer OS Siemreap",
};

export const acceptFile = {
  image: "image/*",
  excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  pdf: ".pdf",
};

export const DueDateOptions = () => {
  const { t } = useTranslation();
  return [
    { label: t("label.manually"), value: "manually" },
    { label: t("label.today"), value: "today" },
    { label: t("label.this_week"), value: "week" },
    { label: t("label.this_week_to_date"), value: "this_week_to_date" },
    { label: t("label.this_month"), value: "month" },
    { label: t("label.this_month_to_date"), value: "this_month_to_date" },
    { label: t("label.this_quarter"), value: "this_quarter" },
    { label: t("label.this_quarter_to_date"), value: "this_quarter_to_date" },
    { label: t("label.this_year"), value: "year" },
    { label: t("label.this_year_to_date"), value: "this_year_to_date" },
    { label: t("label.last_week"), value: "last_week" },
    { label: t("label.last_week_to_date"), value: "last_week_to_date" },
    { label: t("label.last_month"), value: "last_month" },
    { label: t("label.last_month_to_date"), value: "last_month_to_date" },
    { label: t("label.last_quarter"), value: "last_quarter" },
    { label: t("label.last_quarter_to_date"), value: "last_quarter_to_date" },
    { label: t("label.last_year"), value: "last_year" },
    { label: t("label.last_year_to_date"), value: "last_year_to_date" },
    { label: t("label.last_30_days"), value: "last_30_days" },
    { label: t("label.last_365_days"), value: "last_365_days" },
    { label: t("label.to_date"), value: "to_date" },
  ];
};

export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const DefaultFilterOptions = () => {
  const { t } = useTranslation();
  return { label: t("label.all"), value: undefined };
};

export const PaymentStatusOptions = () => {
  const { t } = useTranslation();
  return [
    { label: t("label.all"), value: undefined },
    { label: t("label.succeeded"), value: 2, color: "#68a948", bg: "#f4faf2" },
    { label: t("label.failed"), value: 3, color: "#eb4f5d", bg: "#faf2f3" },
  ];
};

export const paymentStatusOptionsPrint = [
  { label: "Succeeded", value: 2 },
  { label: "Failed", value: 3 },
];

export const ChargingStatusOptions = () => {
  const { t } = useTranslation();
  return [
    { label: t("label.all"), value: undefined },
    { label: t("label.charging"), value: 1, color: "#f9b857", bg: "#fdf7ed" },
    { label: t("label.succeeded"), value: 2, color: "#68a948", bg: "#f4faf2" },
    { label: t("label.canceled"), value: 3, color: "#007bff", bg: "#e6f5ff" },
    { label: t("label.failed"), value: 4, color: "#eb4f5d", bg: "#faf2f3" },
  ];
};

export const chargingStatusOptionsPrint = [
  { label: "Charging", value: 1 },
  { label: "Succeeded", value: 2 },
  { label: "Canceled", value: 3 },
  { label: "Failed", value: 4 },
];

export const ViewOptions = () => {
  const { t } = useTranslation();
  return [
    { label: t("label.summary"), value: 1 },
    { label: t("label.detail"), value: 2 },
  ];
};

export const SaleOrderTypeOptions = () => {
  const { t } = useTranslation();
  return [
    { label: t("label.customer"), value: 1 },
    { label: t("label.driver"), value: 2 },
  ];
};

export const GenderOptions = () => {
  const { t } = useTranslation();
  return [
    { label: t("label.all"), value: undefined },
    { label: t("label.male"), value: 1 },
    { label: t("label.female"), value: 2 },
  ];
};

export const TypeOfContactOptions = () => {
  const { t } = useTranslation();
  return [
    { label: t("label.text"), value: 1 },
    { label: t("label.phone_number"), value: 2 },
    { label: t("label.email"), value: 3 },
    { label: t("label.website"), value: 4 },
  ];
};
